import { motion } from "framer-motion"
import {ChevronDown} from 'lucide-react'
import { useLang } from "@/context/LanguageContext"

export default function HeroSection() {
  const { t } = useLang()

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.lumi.new/dc/dc3e0be754a5704d5bdd1a5656c4db06.webp"
          alt="Bouton Clips'On rouge sur tissu texturé noir"
          className="w-full h-full object-cover object-left"
        />
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to right, rgba(13,12,11,0.15) 0%, rgba(13,12,11,0.45) 40%, rgba(13,12,11,0.7) 65%, rgba(13,12,11,0.8) 100%)"
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl ml-auto mr-6 md:mr-[10%] px-6 text-center md:text-right">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          <p
            className="text-sm tracking-[0.4em] uppercase mb-6"
            style={{ color: "rgba(248, 242, 235, 0.7)" }}
          >
            {t("Bouton vestimentaire innovant", "Innovative clothing button")}
          </p>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="text-5xl md:text-7xl lg:text-8xl leading-[0.95] mb-8 font-light"
          style={{ color: "#FFFFFF" }}
        >
          {t("Le bouton qui", "The button that")}
          <br />
          <span style={{ color: "#E1593F" }}>{t("change tout.", "changes everything.")}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl mx-auto mb-12 leading-relaxed"
          style={{ color: "rgba(248, 242, 235, 0.55)", fontSize: "19px" }}

        >
          {t(
            "Sans couture, sans outil, en un clic. 28 couleurs, une infinité de possibilités. Technologie brevetée en 1995.",
            "No sewing, no tools, just a click. 28 colors, infinite possibilities. Patented in 1995."
          )}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
            onClick={() => scrollTo("catalogue")}
            className="group relative px-10 py-4 text-white text-sm tracking-[0.2em] uppercase transition-all duration-500 overflow-hidden"
            style={{ backgroundColor: "#E1593F" }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#C4462E")}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#E1593F")}
          >
            <span className="relative z-10">{t("Découvrir", "Discover")}</span>
          </button>

          <button
            onClick={() => scrollTo("savoir-faire")}
            className="px-10 py-4 text-sm tracking-[0.2em] uppercase transition-all duration-500"
            style={{
              border: "1px solid rgba(248, 242, 235, 0.25)",
              color: "rgba(248, 242, 235, 0.7)",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = "rgba(225, 89, 63, 0.5)"
              e.currentTarget.style.color = "#E1593F"
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = "rgba(248, 242, 235, 0.25)"
              e.currentTarget.style.color = "rgba(248, 242, 235, 0.7)"
            }}
          >
            {t("Comment ça marche", "How it works")}
          </button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <ChevronDown size={24} style={{ color: "rgba(248, 242, 235, 0.35)" }} />
        </motion.div>
      </motion.div>
    </section>
  )
}
